
const Colors={
    bg:'#fafdf6',
    bg1:"#feffff",
    bg11:"#F5FBFE",
    bg2:"#fbfbfb",
    bg3:"#f5f5f5",
    bgShade1:"#1a73e840", 
    blueBG:'#f7fbfc',
    borderShade1:"#e8f6fb",
    primaryDeep:'#247ba0',
    primary:'#3a7085',
    primary1:'#dbc8ac', 
    primary2:"#8f09f1",
    primary3:"#d5aa6b",
    //primary2:'#993366', 
    primaryShade1:'#c1ebfb',
    primaryShade2:'#e1f8ff',
    primaryShade3:'#c6f0fd',
    primaryShade4:'#a0e9ff',
    primaryShade5:'#36bef8',
    textBlack:'#333533',
    green:"#04cf03",
    green1:'#7cfc00',
    brown:'#b22222',
    purple:"#663399",
    black:'#32425b',
    black1:"#707070",
    blacked:"#000000",
    textGray:'#5f6368',
    gray:"#959ba7",
    gray1:'#f1f3f4',
    gray2:'#dadce0',
    gray3:'#9aa0a6',
    light:"#fff",
    tintedWhite:'#fafdf6',
    lightWhite:'#fdffff', 
    transparentWhite:"#ffffffa8", //  ///rgb(255 255 255 / 66%)
    danger:'#df557a',
  }
  
  export default Colors;
  